import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Checkbox } from "../ui/checkbox";
import { Users, User, Check } from "lucide-react";
import { cn } from "../../lib/utils";

const GIORNI_NOMI = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];

const COLORI_REPARTO = {
  'cucina': { bg: 'bg-orange-100 dark:bg-orange-900/30', text: 'text-orange-700 dark:text-orange-300', dot: 'bg-orange-500', label: 'Cucina' },
  'sala': { bg: 'bg-blue-100 dark:bg-blue-900/30', text: 'text-blue-700 dark:text-blue-300', dot: 'bg-blue-500', label: 'Sala' },
  'laboratorio': { bg: 'bg-purple-100 dark:bg-purple-900/30', text: 'text-purple-700 dark:text-purple-300', dot: 'bg-purple-500', label: 'Lab' },
  'altro': { bg: 'bg-gray-100 dark:bg-gray-900/30', text: 'text-gray-700 dark:text-gray-300', dot: 'bg-gray-500', label: 'Altro' }
};

const getColoreReparto = (reparto) => COLORI_REPARTO[reparto] || COLORI_REPARTO['altro'];

export const AssegnaSlotDialog = ({ open, onOpenChange, slotSelezionato, giorni, operatori, operatoriSelezionati, onToggleOperatore, onSalva }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><Users className="h-5 w-5 text-primary" />Assegna Operatori</DialogTitle>
        {slotSelezionato && (
          <p className="text-sm text-muted-foreground">
            {GIORNI_NOMI[giorni.findIndex(g => g.data === slotSelezionato.data)]} - {slotSelezionato.fascia.nome}
            <br /><span className="text-xs">{slotSelezionato.fascia.ora_inizio} - {slotSelezionato.fascia.ora_fine}</span>
          </p>
        )}
      </DialogHeader>
      <div className="space-y-3 py-2">
        {(() => {
          const reparti = {};
          operatori.forEach(op => { const rep = op.ruolo || 'altro'; if (!reparti[rep]) reparti[rep] = []; reparti[rep].push(op); });
          return Object.entries(reparti).filter(([r]) => r !== 'admin').map(([reparto, ops]) => {
            const colore = getColoreReparto(reparto);
            return (
              <div key={reparto}>
                <div className={cn("flex items-center gap-2 mb-2 px-2 py-1 rounded", colore.bg)}>
                  <div className={cn("w-2 h-2 rounded-full", colore.dot)} />
                  <span className={cn("text-sm font-medium", colore.text)}>{colore.label}</span>
                  <span className="text-xs text-muted-foreground">({ops.length})</span>
                </div>
                <div className="space-y-1">
                  {ops.map(op => {
                    const isSelected = operatoriSelezionati.includes(op.id);
                    return (
                      <button key={op.id} onClick={() => onToggleOperatore(op.id)}
                        className={cn("w-full flex items-center gap-3 p-2 rounded-lg border transition-all", isSelected ? "border-emerald-500 bg-emerald-50 dark:bg-emerald-900/20" : "border-border bg-card hover:bg-muted/50")}
                        data-testid={`assign-operator-${op.id}`}>
                        <Checkbox checked={isSelected} />
                        <User className="h-4 w-4 text-muted-foreground" />
                        <span className="flex-1 text-left text-sm font-medium">{op.nome || op.email || op.telefono}</span>
                        {isSelected && <Check className="h-4 w-4 text-emerald-500" />}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          });
        })()}
      </div>
      <DialogFooter className="gap-2">
        <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">Annulla</Button>
        <Button onClick={onSalva} className="flex-1 bg-emerald-500 hover:bg-emerald-600 text-white"><Check className="h-4 w-4 mr-2" />Salva</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
